<template>
  <vl-action-group mod-align-right>
    <template v-if="isReadOnly">
      <vl-button v-if="canEdit" v-vl-tooltip="infoButtonTooltip" icon="info" mod-icon @click="onInfoClick"></vl-button>
    </template>
    <template v-else>
      <vl-button
        v-vl-tooltip="editButtonTooltip"
        :mod-disabled="!canEdit"
        icon="edit"
        mod-icon
        @click="onEditClick"
      ></vl-button>
      <vl-button v-vl-tooltip="deleteButtonTooltip" icon="trash" mod-icon mod-error @click="onRemoveClick"></vl-button>
    </template>
  </vl-action-group>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

export type GeckoTestActionButtonProps = {
  canEdit?: boolean;
  isReadOnly?: boolean;
  onRemoveClick?: () => void;
  onEditClick?: () => void;
  onInfoClick?: () => void;
};

const { t } = useI18n();

const props = withDefaults(defineProps<GeckoTestActionButtonProps>(), {
  canEdit: true,
  test: null,
  onRemoveClick: null,
  onEditClick: null,
  onInfoClick: null
});

const editButtonTooltip = computed((): string => {
  return props.canEdit ? t('deliveryprocessdefinition.geckoSync.editStandardTestTooltip') : '';
});

const infoButtonTooltip = computed((): string => {
  return props.canEdit ? t('deliveryprocessdefinition.geckoSync.infoStandardTestTooltip') : '';
});

const deleteButtonTooltip = computed((): string => {
  return t('deliveryprocessdefinition.geckoSync.deleteStandardTestTooltip');
});

const onEditClick = () => {
  props.onEditClick?.();
};

const onRemoveClick = () => {
  props.onRemoveClick?.();
};

const onInfoClick = () => {
  props.onInfoClick?.();
};
</script>
